import angular from "angular";
import KategoriaService from "./KategoriaService.js";
import UzivatelService from "./UzivatelService.js";
import KontaktOptionsService from "./KontaktOptionsService.js";
import AktivitaService from "./AktivitaService.js";
import PrilohaService from "./PrilohaService.js";
import ServisPlanOptionsService from "./ServisPlanOptionsService";
import CennikOptionsService from "./CennikOptionsService";
import SviatokService from "./SviatokService";
import TypSubdodavkyService from "./TypSubdodavkyService";
import TypRezieService from "./TypRezieService";
import UserTagService from "./UserTagService";
import TypPoziadavkyService from "./TypPoziadavkyService";
import FilterService from "./FilterService";
import TypRozpisuService from "./TypRozpisuService";
import TemplateService from "./TemplateService";
import PracovnaDobaService from "./PracovnaDobaService";
import BudgetTypeService from "./BudgetTypeService";

export default angular.module("antes.services", [])
.service("KategoriaService", KategoriaService)
.service("KontaktOptionsService", KontaktOptionsService)
.service("UzivatelService", UzivatelService)
.service("AktivitaService", AktivitaService)
.service("PrilohaService", PrilohaService)
.service("ServisPlanOptionsService", ServisPlanOptionsService)
.service("CennikOptionsService", CennikOptionsService)
.service("SviatokService", SviatokService)
.service("TypSubdodavkyService", TypSubdodavkyService)
.service("TypRezieService", TypRezieService)
.service("UserTagService", UserTagService)
.service("TypPoziadavkyService", TypPoziadavkyService)
.service("FilterService", FilterService)
.service("TypRozpisuService", TypRozpisuService)
.service("TemplateService", TemplateService)
.service("BudgetTypeService", BudgetTypeService)
.service("PracovnaDobaService", PracovnaDobaService)
.name;


// WEBPACK FOOTER //
// ./src/services/index.js